export default __webpack_public_path__ + "static/media/wallet.605c4412.png";